<template>
  <div >
    <van-action-sheet
        v-model:show="showFaceType"
        :actions="faceType"
        cancel-text="キャンセル"
        :close-on-click-action="false"
        @select="onSelectFaceType"
    />

    <van-overlay  v-model:show="overlayShow" style="z-index: 2006" :class="[overlayShow ? '' : 'displayClass']">
      <div class="wrapper" @click.stop>
        
        <div class="overlayBox" >

          <div class="title">
          <img src="@/assets/img/launch.png" alt="">
            
          </div>
          <div class="content">
            本人確認ができないため、<br>画面表示がロックされています。
          </div>
        </div>
      </div>
    </van-overlay>

    <input type="file" ref="dzImageFile" style="display: none" @change="dzImgFileChange" value=""/>
  </div>
</template>

<script>

import {Toast,Dialog} from "vant";
import "vant/es/toast/style";

export default {
  name: "DzAndroid",
  props: {
  },
  data() {
    return {
      showFaceType: false,
      faceType: [{ name: '顔認証' ,value:"typeFace"}, { name: '画像認証',value:"typeImg" }],
      overlayShow:false,
      hasSelectFaceType:false,
      loadingToast:null,
      // 暂时关闭flg
      temporaryStopFlg:false,
      // 功能开启标识
      functionOpenFlg:false,
      // 不需要功能页面
      noDzPage:{
        paths:['/login','/beforeCall','/beforeRoom','/monitorRoom','/singleCall','/roomConversation'],
        includes(route) {
          return (
             this.paths.includes(route.path)
          );
        },
      },
      firstLoad:true,
      isAndroid:false,
    };
  },
  mounted() {
    this.iosOrAndroid();
  },
  watch:{
    showFaceType(newVal,oldVal){
      if(!newVal && !this.hasSelectFaceType){
        // 弹出选择栏目，然是没有选择
        this.doCancelFaceType();
      }
    },
    $route(newValue) {
      // 本地环境暂时屏蔽
      let url = window.location.href;
      if (url.indexOf("localhost") !== -1) {
        return;
      }
      if(!this.isAndroid || this.$root.monitorRoom !== ""){
        return;
      }
      if (typeof cordova === "undefined") {
        // 无需进行处理
        Toast('Dz機能異常');
      }else{
        // 主动进入页面
        if(this.noDzPage.includes(newValue)){
          this.temporaryStopDz();
        }else{
          // 方法内有判断，如果是临时停止的话 就恢复
          this.recoveryDz();
        }
      }
    },
  },
  methods: {
    doCancelFaceType(){
      // 发送给dzPage页面 将on/off调整为off
      this.$emit("dzAndroid",{toPage:"dzPage",method:"cancelFaceType"});
    },
    doMethods(params){
      if(!this.isAndroid){
        return;
      }
      if (typeof cordova === "undefined") {
        // 无需进行处理
        Toast('Dz機能異常');
      }else{
        if(params['method'] == 'changeDzStatus'){
          this.changeDzStatus(params['status']);
        }else if(params['method'] == 'changeShowFaceType'){
          this.showFaceType = true;
        }else if(params['method'] == 'clearFace'){
          this.clearFace();
        }else if(params['method'] == 'temporaryStopDz'){
          this.temporaryStopDz();
        }else if(params['method'] == 'recoveryDz'){
          this.recoveryDz();
        }
      }
    },
    temporaryStopDz(){
      // 临时停止dz认证
      let dzOpenFlg = this.getLocalStorage();
      if(dzOpenFlg == 'open' && this.functionOpenFlg){
        this.temporaryStopFlg = true;
        this.DzStop();
      }
    },
    recoveryDz(){
      // 所处页面check
      if(this.noDzPage.includes(this.$route)){
        return;
      }
      // 初次加载，如果未开启功能需要开启
      let dzOpenFlg = this.getLocalStorage();
      if(dzOpenFlg == 'open' && this.firstLoad){
        this.firstLoad = false;
        this.changeDzStatus('open');
      }
      // 恢复dz认证
      if(this.temporaryStopFlg){
        this.temporaryStopFlg = false;
        this.changeDzStatus('open');
      }
    },
    checkDzExist() {
      setTimeout(() => {
        let dzOpenFlg = this.getLocalStorage();
        this.changeDzStatus(dzOpenFlg);
      },1000);
    },
    changeDzStatus(dzOpenFlg){
      this.loadingToast = Toast.loading({
        message: "dz認証中...",
        duration: 0,
        forbidClick: true,
      });
      if("open" ==dzOpenFlg){
        this.DzPrepare();
      }else{
        this.loadingToast.clear();
        this.setLocalStorage('close');
        this.DzStop();
      }
    },
    getLocalStorage(){
      return localStorage.getItem("tsunagaru_dz_status");
    },
    setLocalStorage(value){
      localStorage.setItem("tsunagaru_dz_status",value)
    },
    clearFace(){
      Dialog.confirm({
        title: '資格認定情報の消去',
        message: '認証情報のクリアを確認しますか？',
      })
      .then(() => {
        this.DzEraseAllDataAndReset();
      })
      .catch(() => {
      });
    },
    DzPrepare() {
      cordova.exec(
        (result) => {
          if ("ok" == result) {
            setTimeout(()=>{
              // 检测是否有认证过的面部资源
              this.DzCheckFaceRegistered();
            },1000);
          }
          console.log('Received result from Java: ' + result);
        },
         (error)=> {
          // 开启失败
          this.loadingToast.clear();
          this.doCancelFaceType();
          console.error('Error from Java: ' + error);
        },
        "MyPluginApi",
        "DzPrepare",
        []
      );
    },
    DzCheckFaceRegistered() {
      cordova.exec(
          (result) => {
            if ("ok" == result) {
              // 拥有面部注册
              this.DzEnginePreparationPostProcess();
            } else {
              // 先去注册
              this.loadingToast.clear();
              this.hasSelectFaceType = false;
              this.showFaceType = true;
            }
            console.log('Received result from Java: ' + result);
          },
           (error) => {
            // 检测失败
            this.loadingToast.clear();
            this.doCancelFaceType();
            console.error('Error from Java: ' + error);
          },
          "MyPluginApi",
          "DzCheckFaceRegistered",
          []
      );
    },
    onSelectFaceType(item) {
      if ("typeFace" == item.value) {
        this.DzStartSeamlessFaceRegistration();
      } else if ("typeImg" == item.value) {
        this.$refs.dzImageFile.click();
      }
    },
    DzStartSeamlessFaceRegistration() {
      this.hasSelectFaceType = true;
      this.showFaceType = false;
      // 认证比较慢 加一个loading
      Toast.loading({
        message: "dz認証中...",
        duration: 0,
        forbidClick: true,
      });
      // 视频认证
      cordova.exec(
          (result) => {
            if (result == "ok") {
              // 顔登録成功
              Toast('資格認定に成功しました');
              this.DzEnginePreparationPostProcess();
            } else {
              // 認証失败
              this.doCancelFaceType();
              Toast.clear();
              Toast('認証に失敗しました');
            }
            console.log('Received result from Java: ' + result);
          },
          (error) => {
            // 認証失败
            this.doCancelFaceType();
            Toast.clear();
            console.error('Error from Java: ' + error);
          },
          "MyPluginApi", // Java class name
          "DzStartSeamlessFaceRegistration",
          []
      );
    },
    dzImgFileChange(e) {
      if (e.target.files.length <= 0) {
        this.showFaceType = false;
        Toast('認証に失敗しました');
        return;
      }
      this.hasSelectFaceType = true;
      this.showFaceType = false;
      // 认证比较慢 加一个loading
      Toast.loading({
        message: "dz認証中...",
        duration: 0,
        forbidClick: true,
      });
      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onloadend = () => {
        var base64data = reader.result;
        this.DzRegisterFaceDirectly(base64data);
      };
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    DzRegisterFaceDirectly(base64data) {
      cordova.exec(
          (result) => {
            if (result == "ok") {
              // 顔登録成功
              Toast('資格認定に成功しました');
              this.DzEnginePreparationPostProcess();
            } else {
              // 認証失败
              this.doCancelFaceType();
              Toast.clear();
              this.showFaceType = false;
              Toast('認証に失敗しました');
            }
            console.log('Received result from Java: ' + result);
          },
          (error) => {
            // 認証失败
            this.doCancelFaceType();
            Toast.clear();
            console.log("Error: " + error);
          },
          "MyPluginApi",
          "DzRegisterFaceDirectly",
          [base64data]
      );
    },
    DzEnginePreparationPostProcess() {
      this.functionOpenFlg = true;
      this.setLocalStorage('open');
      setTimeout(() => {
        cordova.exec(
             (result) => {
               this.loadingToast.clear();
              if (result == "AuthOk") {
                this.overlayShow = false;
              } else {
                this.overlayShow = true;
              }
              console.log('Received result from Java: ' + result);
            },
             (error) => {
              // 开启失败
               this.loadingToast.clear();
               this.setLocalStorage('close');
               this.doCancelFaceType();
               Toast('オープンに失敗しました');
              console.error('Error from Java: ' + error);
            },
            "MyPluginApi",
            "DzEnginePreparationPostProcess",
            []
        );
      }, 1000);
    },
    DzStop() {
      this.functionOpenFlg = false;
      this.overlayShow = false;
      cordova.exec(
       (result) => {
        console.log('Received result from Java: ' + result);
      },
       (error)=> {
        console.error('Error from Java: ' + error);
      },
      "MyPluginApi",
      "DzStop",
      []
      );
    },
    DzEraseAllDataAndReset(){
      cordova.exec(
          (result) =>{
            if("ok" == result){
              Toast('資格認定情報の削除に成功しました');
            }
            console.log('Received result from Java: ' + result);
          },
          (error) =>{
            Toast('認証情報の削除に失敗しました');
            console.error('Error from Java: ' + error);
          },
          "MyPluginApi",
          "DzEraseAllDataAndReset",
          []
      );
    },
    iosOrAndroid(){
      let url = window.location.href;
      if (url.indexOf("android") !== -1) {
        console.log("URL contains 'android'");
        this.isAndroid = true;
      } else {
        console.log("URL does not contain 'android'");
        this.isAndroid = false;
      }
    },
  },
};
</script>

<style scoped>
  .displayClass{
    display: none;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background-color: #3c82c4;
  }

  .overlayBox {
    width: 70%;
    /* height: 90px; */
    /* background-color: #fff; */
    align-items: center;
    justify-content: center;
    /* border-radius: 4px; */
    /* border: 1px solid white; */
  }
  .overlayBox  img{
    width: 140px;
    margin-bottom: 20px;
  }
  .overlayBox .title{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 18px;
  }
  .overlayBox .content{
    text-align: center;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: 1px solid white; */
    /* padding: 10px 10px 30px; */
    border-radius: 4px;
    font-size: 18px;
    line-height: 24px;

  }
</style>
